<template>
  <div class="data-list-display-settings-button">
    <span
      ref="openConfigButton"
      class="btn _btn-outline-secondary btn-sm data-list-display-settings-button--button"
      @click.prevent.stop="
          () => {
            $refs.colSettingModal.show()
            $refs.colSettingPop?.hide?.()
          }
        "
    >
      <ficon type="cog" />
    </span>
    <b-popover
      :target="() => $refs.openConfigButton"
      ref="colSettingPop"
      :triggers="['click']"
      hide-footer
      body-class="p-0"
      class="popover-body-no-padding"
      centered
      title=""
    >
      <span
        class="btn btn-outline-secondary btn-sm btn-block border-0"
        @click.prevent.stop="
          () => {
            $refs.colSettingModal.show()
            $refs.colSettingPop.toggle()
          }
        "
        ><ficon type="list-ul" /> カラム順序・表示の設定</span
      >
    </b-popover>
    <b-modal
      ref="colSettingModal"
      ok-only
      ok-title="閉じる"
      ok-variant="outline-secondary"
      display-type="sidebar"
      :hide-footer="true"
    >
      <template #title>
        カラム順序・表示の設定
        <span
          v-if="modelNameLabel"
          class="text-muted"
        >
          -
          <code>{{ modelNameLabel }}</code>
        </span>
      </template>
      <div class="data-list-display-settings-button--modal-body">
        <HelpDoc>
          一覧表示時のカラム順序や表示/非表示の設定を行うことができます。
          この設定は、個人設定として保存され、他の人には適用されません。
        </HelpDoc>
      </div>
      <DataListDisplayColumnOrderAndVisiblitySettingEdit
        @close="() => $refs.colSettingModal.hide()"
        @saved="() => $refs.colSettingModal.hide()"
      />
    </b-modal>
  </div>
</template>

<script lang="ts">
import { inject } from 'vue'
import { DataListDisplayService } from '../DataListDisplayService'
import { registerComposableComponentSettings } from '../../../../../ComposableComponents'

const name = 'DataListDisplaySettingsButton'
registerComposableComponentSettings(name, {
  hasDefaultSlot: false,
  label: 'データ一覧表示設定',
  description: 'データ一覧表示のカラム順序・表示の設定を行うためのボタン',
})

export default {
  name,
  components: {
    DataListDisplayColumnOrderAndVisiblitySettingEdit:
      $frameworkUtils.defineAsyncComponent(
        () => import('./DataListDisplayColumnOrderAndVisiblitySettingEdit.vue'),
      ),
  },
  setup() {
    const DataListDisplayServiceInstance = inject<DataListDisplayService>(
      'DataListDisplayServiceInstance',
    ) as DataListDisplayService
    return {
      DataListDisplayServiceInstance,
    }
  },
  computed: {
    modelNameLabel() {
      return (
        this.DataListDisplayServiceInstance?.ComposableDataListServiceInstance
          ?.virtualModel?.tableLabel ||
        this.DataListDisplayServiceInstance?.ComposableDataListServiceInstance?.model
          ?.tableLabel ||
        ''
      )
    },
  },
  async mounted() {
    // // debug 用
    // setTimeout(() => {
    //   this.$refs.modal.show()
    // }, 1000)
  },
}
</script>

<style lang="scss">
.data-list-display-settings-button--button {
  opacity: 0.8;
  &:hover {
    opacity: 1;
  }
}
</style>
